import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The single "Sources" page was split into per-source pages (Email / WhatsApp
 * / Meetings) reachable from the AI Suggestions submenu. Kept as a redirect so
 * old links / bookmarks still land somewhere sensible.
 */
export const Route = createFileRoute("/_app/analysis/sources")({
  beforeLoad: () => {
    throw redirect({ to: "/agents/$slug/$tab", params: { slug: "analyst", tab: "email" } });
  },
});
